// extracted by mini-css-extract-plugin
module.exports = {"Blockquote":"Blockquote_Blockquote__SrgwI","Footer":"Blockquote_Footer__ONF6T"};